import Vue from 'vue';

export default {
    init(el) {
        new Vue({
            el: el,
            name: 'Video Popup',
            data() {
                return {
                    videoPlaying: false,
                    video: null,
                    videoId: $(el).data('video-id')
                }
            },
            mounted() {
                let self = this;
                window._wq.push({
                    id: this.videoId,
                    options: {
                        playButton: false
                    },
                    onReady: video => {
                        self.video = video;
                    }
                });
            },
            methods: {
                playVideo() {
                    if (this.video.state() === "playing") {
                        this.videoPlaying = false;
                        this.video.pause();
                    } else {
                        this.videoPlaying = true;
                        this.video.play();
                    }
                },
                closeVideo() {
                    this.videoPlaying = false;
                    this.video.pause();
                }
            },

        })
    }
}
